 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activate-btc":"activate-btc","activate-polygon":"activate-polygon","add-account":"add-account","add-vesting-contract":"add-vesting-contract","cashlink":"cashlink","change-password":"change-password","checkout":"checkout","choose-address~connect-account":"choose-address~connect-account","choose-address":"choose-address","connect-account":"connect-account","electrum-client":"electrum-client","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90","activate-btc-ledger":"activate-btc-ledger","add-ledger":"add-ledger","refund-swap-ledger":"refund-swap-ledger","sign-btc-transaction-ledger":"sign-btc-transaction-ledger","sign-message-ledger":"sign-message-ledger","sign-transaction-ledger":"sign-transaction-ledger","swap~swap-ledger":"swap~swap-ledger","swap-ledger":"swap-ledger","common":"common","cookie-decoder":"cookie-decoder","export":"export","lang-de-po":"lang-de-po","lang-en-po":"lang-en-po","lang-es-po":"lang-es-po","lang-fil-po":"lang-fil-po","lang-fr-po":"lang-fr-po","lang-nl-po":"lang-nl-po","lang-pt-po":"lang-pt-po","lang-ru-po":"lang-ru-po","lang-tr-po":"lang-tr-po","lang-uk-po":"lang-uk-po","lang-zh-po":"lang-zh-po","logout":"logout","logout-ledger":"logout-ledger","migrate":"migrate","onboarding":"onboarding","rename":"rename","request-error":"request-error","sign-btc-transaction":"sign-btc-transaction","sign-message":"sign-message","sign-multisig-transaction":"sign-multisig-transaction","sign-polygon-transaction":"sign-polygon-transaction","sign-staking":"sign-staking","sign-transaction":"sign-transaction","swap":"swap","unsupported-ledger":"unsupported-ledger"}[chunkId]||chunkId) + "." + {"activate-btc":"2088d78f","activate-polygon":"a985194d","add-account":"419a9f79","add-vesting-contract":"cd994440","cashlink":"15278b6c","change-password":"d7bfb8b0","checkout":"ce1901bd","choose-address~connect-account":"d273a4fe","choose-address":"41471d96","connect-account":"55ff1220","chunk-29173a98":"ae018744","chunk-412aa1ee":"f1e9ddd4","chunk-42f071ba":"2881ae43","electrum-client":"93b4e270","chunk-58da8a1c":"b46c841d","chunk-2d0b1fa8":"3b499fb1","chunk-2d0e580c":"416c1e5b","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"c74a5920","activate-btc-ledger":"5b18d881","add-ledger":"1ca2708d","refund-swap-ledger":"ed8a94eb","sign-btc-transaction-ledger":"79992e6e","sign-message-ledger":"ed1f23d4","sign-transaction-ledger":"a5b02beb","swap~swap-ledger":"9fa35d64","swap-ledger":"4f2bb1e4","chunk-2d0c1ee9":"ccb61e0b","chunk-2d237ef5":"ea9107d9","common":"f269714d","cookie-decoder":"f6554258","export":"35ca85a4","lang-de-po":"b7bbe6b7","lang-en-po":"b8f425fb","lang-es-po":"40d726e7","lang-fil-po":"1b3380ca","lang-fr-po":"27700881","lang-nl-po":"9d6b3f18","lang-pt-po":"7c50b2e5","lang-ru-po":"afd9df63","lang-tr-po":"f61108f4","lang-uk-po":"890527b7","lang-zh-po":"aab70fd8","logout":"e7b1aa7c","logout-ledger":"3e80f0b8","migrate":"f55e1bee","onboarding":"60ea1dc2","rename":"2504f083","request-error":"26a752ca","sign-btc-transaction":"43d55e3e","sign-message":"41cb8e67","sign-multisig-transaction":"9f3c195b","sign-polygon-transaction":"8c4aefde","sign-staking":"5c89a843","sign-transaction":"92393dae","swap":"ce0ce03b","unsupported-ledger":"68f4846e","chunk-0151f112":"01673922","chunk-08b6bd98":"e669a6f3","chunk-2020f754":"dabd8a17","chunk-23dda218":"4055952f","chunk-2d0aecce":"2e10d18c","chunk-37933883":"60f49668","chunk-3ebf6ebc":"027ed964","chunk-525f9242":"117cfbab","chunk-599354e3":"72a5f861","chunk-67604d98":"c320eb7e","chunk-696b939d":"c01766a2","chunk-7648a4f0":"42bc51d7","chunk-85163008":"06e2d241","chunk-8724e426":"519815aa","chunk-4142fd92":"35fe6654","chunk-296285c8":"c7b33883","chunk-522442ab":"31b017a6","chunk-6664cac8":"8904a3d3","chunk-56879cc1":"a34a0ae6","chunk-90c19bce":"72e23d98","chunk-97f6e3c0":"78bc12fd","chunk-a1e4442c":"eae6c475","chunk-ad6f4d72":"f3b1c1c2","chunk-dc4049b0":"7af17f61","chunk-2af39605":"6eadb4ea","chunk-2d216055":"f5aa254b","chunk-b15e8a52":"7be134d3","chunk-f44fb8c6":"39fa3d4d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activate-btc":1,"activate-polygon":1,"add-account":1,"add-vesting-contract":1,"cashlink":1,"checkout":1,"choose-address~connect-account":1,"choose-address":1,"connect-account":1,"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":1,"add-ledger":1,"refund-swap-ledger":1,"sign-btc-transaction-ledger":1,"sign-message-ledger":1,"sign-transaction-ledger":1,"swap-ledger":1,"common":1,"export":1,"logout":1,"logout-ledger":1,"migrate":1,"onboarding":1,"rename":1,"request-error":1,"sign-btc-transaction":1,"sign-message":1,"sign-multisig-transaction":1,"swap":1,"unsupported-ledger":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activate-btc":"activate-btc","activate-polygon":"activate-polygon","add-account":"add-account","add-vesting-contract":"add-vesting-contract","cashlink":"cashlink","change-password":"change-password","checkout":"checkout","choose-address~connect-account":"choose-address~connect-account","choose-address":"choose-address","connect-account":"connect-account","electrum-client":"electrum-client","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90","activate-btc-ledger":"activate-btc-ledger","add-ledger":"add-ledger","refund-swap-ledger":"refund-swap-ledger","sign-btc-transaction-ledger":"sign-btc-transaction-ledger","sign-message-ledger":"sign-message-ledger","sign-transaction-ledger":"sign-transaction-ledger","swap~swap-ledger":"swap~swap-ledger","swap-ledger":"swap-ledger","common":"common","cookie-decoder":"cookie-decoder","export":"export","lang-de-po":"lang-de-po","lang-en-po":"lang-en-po","lang-es-po":"lang-es-po","lang-fil-po":"lang-fil-po","lang-fr-po":"lang-fr-po","lang-nl-po":"lang-nl-po","lang-pt-po":"lang-pt-po","lang-ru-po":"lang-ru-po","lang-tr-po":"lang-tr-po","lang-uk-po":"lang-uk-po","lang-zh-po":"lang-zh-po","logout":"logout","logout-ledger":"logout-ledger","migrate":"migrate","onboarding":"onboarding","rename":"rename","request-error":"request-error","sign-btc-transaction":"sign-btc-transaction","sign-message":"sign-message","sign-multisig-transaction":"sign-multisig-transaction","sign-polygon-transaction":"sign-polygon-transaction","sign-staking":"sign-staking","sign-transaction":"sign-transaction","swap":"swap","unsupported-ledger":"unsupported-ledger"}[chunkId]||chunkId) + "." + {"activate-btc":"a9060c70","activate-polygon":"a9060c70","add-account":"e8f97a43","add-vesting-contract":"9d5afa69","cashlink":"8c409bbe","change-password":"d41d8cd9","checkout":"733dd733","choose-address~connect-account":"a9060c70","choose-address":"942d1018","connect-account":"fc23208b","chunk-29173a98":"d41d8cd9","chunk-412aa1ee":"d41d8cd9","chunk-42f071ba":"d41d8cd9","electrum-client":"d41d8cd9","chunk-58da8a1c":"d41d8cd9","chunk-2d0b1fa8":"d41d8cd9","chunk-2d0e580c":"d41d8cd9","activate-btc-ledger~add-ledger~refund-swap-ledger~sign-btc-transaction-ledger~sign-message-ledger~si~00675b90":"452d58d3","activate-btc-ledger":"d41d8cd9","add-ledger":"da0749af","refund-swap-ledger":"d691255b","sign-btc-transaction-ledger":"f068edc9","sign-message-ledger":"994b64c6","sign-transaction-ledger":"841bc4ad","swap~swap-ledger":"d41d8cd9","swap-ledger":"8dacd8db","chunk-2d0c1ee9":"d41d8cd9","chunk-2d237ef5":"d41d8cd9","common":"71d2c8d0","cookie-decoder":"d41d8cd9","export":"71d2c8d0","lang-de-po":"d41d8cd9","lang-en-po":"d41d8cd9","lang-es-po":"d41d8cd9","lang-fil-po":"d41d8cd9","lang-fr-po":"d41d8cd9","lang-nl-po":"d41d8cd9","lang-pt-po":"d41d8cd9","lang-ru-po":"d41d8cd9","lang-tr-po":"d41d8cd9","lang-uk-po":"d41d8cd9","lang-zh-po":"d41d8cd9","logout":"71d2c8d0","logout-ledger":"4af0f788","migrate":"ce303082","onboarding":"1ac2fc69","rename":"b4fdafca","request-error":"71d2c8d0","sign-btc-transaction":"a9060c70","sign-message":"fc19f920","sign-multisig-transaction":"71d2c8d0","sign-polygon-transaction":"d41d8cd9","sign-staking":"d41d8cd9","sign-transaction":"d41d8cd9","swap":"a9060c70","unsupported-ledger":"a9060c70","chunk-0151f112":"d41d8cd9","chunk-08b6bd98":"d41d8cd9","chunk-2020f754":"d41d8cd9","chunk-23dda218":"d41d8cd9","chunk-2d0aecce":"d41d8cd9","chunk-37933883":"d41d8cd9","chunk-3ebf6ebc":"d41d8cd9","chunk-525f9242":"d41d8cd9","chunk-599354e3":"d41d8cd9","chunk-67604d98":"d41d8cd9","chunk-696b939d":"d41d8cd9","chunk-7648a4f0":"d41d8cd9","chunk-85163008":"d41d8cd9","chunk-8724e426":"d41d8cd9","chunk-4142fd92":"d41d8cd9","chunk-296285c8":"d41d8cd9","chunk-522442ab":"d41d8cd9","chunk-6664cac8":"d41d8cd9","chunk-56879cc1":"d41d8cd9","chunk-90c19bce":"d41d8cd9","chunk-97f6e3c0":"d41d8cd9","chunk-a1e4442c":"d41d8cd9","chunk-ad6f4d72":"d41d8cd9","chunk-dc4049b0":"d41d8cd9","chunk-2af39605":"d41d8cd9","chunk-2d216055":"d41d8cd9","chunk-b15e8a52":"d41d8cd9","chunk-f44fb8c6":"d41d8cd9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
